module.exports = __webpack_public_path__ + "VAGRoundedStd-Light.b172bdb2963f1e96abb3.otf";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.otf
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.otf
// module chunks = styles